import { Typography, Select, MenuItem, Box } from "@material-ui/core";
import { useState, useMemo, useEffect } from "react";
import { ProbeOfflineCondition } from "../../../../api/automation";
import { SubConditionInput, Spacer } from "./Helpers";

const thresholdOptions = [30, 60, 120];

export const ProbeOfflineConditionInput: SubConditionInput<
  ProbeOfflineCondition
> = ({ value, onChange }) => {
  const [thresholdMinutes, setThresholdMinutes] = useState<number>(
    value.threshold_minutes ?? 30
  );

  const result = useMemo<ProbeOfflineCondition>(
    () => ({ type: "probe_offline", threshold_minutes: thresholdMinutes }),
    [thresholdMinutes]
  );

  useEffect(() => {
    onChange(result);
  }, [result]);

  return (
    <Box>
      <Typography>
        When the moisture probe has not reported for more than
        <Spacer>
          <Select
            value={thresholdMinutes}
            onChange={(e) => setThresholdMinutes(Number(e.target.value))}
          >
            {thresholdOptions.map((m) => (
              <MenuItem value={m} key={m}>
                {m} minutes
              </MenuItem>
            ))}
          </Select>
        </Spacer>
      </Typography>
    </Box>
  );
};
